export const customMedia = {
    'extra-small': {
        min: 0,
        max: '33.6875rem', // 539px
        to: '33.6875rem', // 539px
        from: '33.75rem', // 540px
    },
    small: {
        min: '33.75rem', // 540px
        max: '44.9375rem', // 719px
        to: '44.9375rem', // 719px,
        from: '45rem', // 720px
    },
    medium: {
        min: '45rem', // 720px
        max: '54.9375rem', // 879px
        to: '54.9375rem', // 879px
        from: '55rem', // 880px
    },
    large: {
        min: '55rem', // 880px
        max: '63.9375rem', // 1023px
        to: '63.9375rem', // 1023px
        from: '64rem', // 1024px
    },
    'extra-large': {
        min: '64rem', // 1024px
        max: Infinity,
        to: Infinity,
        from: Infinity,
    },
};
//# sourceMappingURL=customMedia.js.map